import type { Transaction } from '@/types/Transaction';
import { applyIva, centsDiff } from './money';

export interface ValidationViolation {
  transactionId: string;
  rowIndex: number;
  supplier: string;
  monthKey: string;
  net: number;
  refundExpected: number;
  refundActual: number;
  diffCents: number;
}

export interface ValidationResult {
  total: number;
  passed: number;
  violations: ValidationViolation[];
  allValid: boolean;
}

/**
 * Verifica que para cada Transaction, refund (col F) = ROUND(net × 1,22, 4) ± 0,01.
 * Tolerância: 1 cêntimo (limite definido no PROMPT_DASHBOARD §2.3).
 *
 * Violações > 0 indicam:
 *   - linha mal preenchida no .xlsx (humano forçou valor que não fecha)
 *   - bug no parser (improvável após F1.1 estabilizar)
 *   - fornecedor categoria especial onde D ≠ E (mas F = E×1,22 deve manter-se)
 */
export function validateTransactions(transactions: Transaction[]): ValidationResult {
  const violations: ValidationViolation[] = [];
  for (const t of transactions) {
    const refundExpected = applyIva(t.net);
    const diff = centsDiff(t.refund, refundExpected);
    if (diff >= 0.01) {
      violations.push({
        transactionId: t.id,
        rowIndex: t.rowIndex,
        supplier: t.supplier,
        monthKey: t.monthKey,
        net: t.net,
        refundExpected,
        refundActual: t.refund,
        diffCents: diff,
      });
    }
  }
  return {
    total: transactions.length,
    passed: transactions.length - violations.length,
    violations,
    allValid: violations.length === 0,
  };
}
